// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18wGb","input":"styles_input__OZ9ZZ"};